import { defineMessages } from 'react-intl';

const messages = defineMessages({
  serviceCollectionsTitle: {
    description: 'title to tell users about rate shoppers in the Rate Shopper selector dropdown',
    defaultMessage: 'Rate Shopper',
    id: 'AHaLxN',
  },
  serviceCollectionsMessage: {
    description: 'a message describing what Rate Shopper are',
    defaultMessage: 'Group services to compare rates.',
    id: 'dYxCy/',
  },
  serviceCollectionsLink: {
    description: 'links to the Rate Shopper settings page to let users manage them',
    defaultMessage: '<a>Manage Rate Shoppers</a>',
    id: 'SMaysd',
  },
  sortBy: {
    description: 'sort by for shipping services',
    defaultMessage: 'Sort by',
    id: 'f7Msda',
  },
});

export default messages;
